import {
	ClientInformationRequest,
	InformationRequest,
	InformationRequestSchema,
	InformationRequestSpec,
	StatusBadgeOptions,
	ViewType,
} from '../components/common/types';
import {
	DataProvider,
	UpdateMetaRequestPayload,
	UpdateSchemaRequestPayload,
} from './types';

const informationRequestRID = 'sharefile:account-123/project-456/inforeq-789';
export const useSpecEditDataProvider = (
	resourceSpec: InformationRequestSpec,
	onUpdate: (value: InformationRequestSpec) => void
): DataProvider => {
	let updatedSchema: InformationRequestSchema | undefined = undefined;

	return {
		async getInformationRequests(
			_containerId: string,
			_view?: ViewType,
			_isDeleted?: boolean,
			_take?: number,
			_skip?: number
		): Promise<any> {
			return [
				{
					informationRequestRID,
					informationRequestStatus: StatusBadgeOptions.Draft,
					totalAssigned: 0,
					totalSubmitted: 0,
					containerID: informationRequestRID,
					...resourceSpec,
				},
			];
		},
		getInformationRequestsByUser(): Promise<ClientInformationRequest[]> {
			throw new Error('Function not implemented.');
		},
		async getInformationRequest(
			_informationRequestRID: string
		): Promise<InformationRequest> {
			return {
				informationRequestRID,
				informationRequestStatus: StatusBadgeOptions.Draft,
				totalAssigned: 0,
				totalSubmitted: 0,
				containerID: informationRequestRID,
				...resourceSpec,
			};
		},
		createInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		async updateInformationRequestSchema(
			_informationRequestRID: string,
			payload: UpdateSchemaRequestPayload
		): Promise<any> {
			updatedSchema = payload.informationRequestSchema; // updateInformationRequestMeta immediately called after, prevent two updates
		},
		async updateInformationRequestMeta(
			_informationRequestRID: string,
			payload: UpdateMetaRequestPayload
		): Promise<any> {
			onUpdate({
				...resourceSpec,
				name: payload.name ?? '',
				description: payload.description,
				dueDate: payload.dueDate,
				thankYouMessage: payload.thankYouMessage as string,
				...(updatedSchema && { informationRequestSchema: updatedSchema }),
			});
			updatedSchema = undefined;
		},
		setAssigneeToInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		async getInformationResponses(): Promise<any> {
			return [];
		},
		getInformationResponse(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		getInformationResponseByResponseRID(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		createInformationResponse(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		deleteAssigneeFromInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		deleteInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		closeInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		duplicateInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		restoreInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		remindAssigneesInformationRequest(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		getConnectedEntityData(): Promise<any> {
			throw new Error('Function not implemented.');
		},
		exportInformationResponses(): Promise<{
			filename: string;
			rowCount: number;
			content: string;
		}> {
			throw new Error('Function not implemented.');
		},
		createInformationRequestWithAI(): Promise<any> {
			throw new Error('Function not implemented.');
		},
	};
};
